import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import OrderDetails from "./OrderDetails";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTable from "../../../shares/PanelTable";

const AdminReportsReqInvReg = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [providerFilter, setProviderFilter] = useState(null);

  const headersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "name", name: "نام تولیدکننده" },
    { colName: "weight_one", name: " یک" },
    { colName: "weight_two", name: " دو" },
    { colName: "weight_three", name: " سه" },
    { colName: "weight_four", name: " چهار" },
    { colName: "weight_five", name: " پنج" },
    { colName: "weight_six", name: " شش" },
    { colName: "register", name: " ثبتی ادمین" },
  ];

  const mobileHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
  ];

  const dataKey = [
    "code",
    "show_name",
    "brand",
    "gender",
    "color",
    "name",
    "object.total_bangle_stock_with_request.size_one_num",
    "object.total_bangle_stock_with_request.size_two_num",
    "object.total_bangle_stock_with_request.size_three_num",
    "object.total_bangle_stock_with_request.size_four_num",
    "object.total_bangle_stock_with_request.size_five_num",
    "object.total_bangle_stock_with_request.size_six_num",
  ];

  const [providerPagination, setProviderPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [providerList, setProviderList] = useState({ results: [] });

  const getProvidersApi = useFetch({
    method: "get",
    url: "Provider_Service",

    trigger: true,
    pagination: providerPagination,
    setter: setProviderList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    // {
    //   type: "textField",
    //   label_fa: "وضعیت",
    //   label_en: "state",
    //   state: stateFilter,
    //   isLTR: true,
    // },
    // {
    //   type: "textField",
    //   label_fa: "تولیدکننده",
    //   label_en: "provider",
    //   state: providerFilter,
    //   isLTR: true,
    // },
    {
      type: "select",
      label_fa: "وضعیت",
      label_en: "state",
      state: stateFilter,
      menuItems: [
        { name: "منتظر تایید", value: "waiting" },
        { name: "در حال اجرا", value: "onprogress" },
        { name: "کامل شده", value: "complete" },
      ],
      // fromApi: true,
    },
    {
      type: "select",
      label_fa: "تولیدکننده",
      label_en: "provider",
      state: providerFilter,
      menuItems: providerList.results,
      fromApi: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "state") setStateFilter(e.length > 0 ? e : null);
    if (state == "provider") setProviderFilter(e);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setStateFilter(null);
    setProviderFilter(null);
    getRequestListApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const handelPrintReport = () => {
    navigate("/print-report-request-inventory-register");
  };

  const [requestList, setRequestList] = useState([]);

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
      provider: providerFilter,
      state: stateFilter,
    },
    url: `User_Service/${useUserData.username}/admin_get_report_provider_request`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [
    {
      label: "ثبتی ادمین",
      component: (it) => (
        <OrderDetails RemoveOrder selectedRow={it} data={it.request_extra} />
      ),
    },
  ];

  const actionsList = [];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList([]);
    getRequestListApi.reFetch();
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-request-inventory-register">
        <div className="panel-main-header">
          <span>درخواست ها، موجودی و تعداد ثبت شده النگوها</span>
        </div>
        <PanelFilter
          header="فیلتر :"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />
        <div className="flex justify-end">
          <MuiButton
            onClick={handelPrintReport}
            variant="outlined"
            icon={<PrintIcon />}
            color="primary"
            text="چاپ گزارش"
            margin="mr-2"
          />
        </div>
        <PanelTable
          header="لیست النگوها:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={requestList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AddShoppingCartIcon />}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminReportsReqInvReg;
